
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import CategoryMixin from "~/node_modules/sitis-nuxt/lib/mixins/CategoryMixin";
import {
  Product
} from "~/node_modules/sitisjs/dist/internal/sections/products/models/Product";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";
import {pickSeoTitle} from "~/helpers/seo-title";

export default {
  name: "Category",

  head: function () {
    const description = this.category?.seo?.description || this.category?.metaDescription || "";
    let title = `Перевозка грузов до ${this.category?.name}`;
    if (this.category?.name === '20 - 100 тонн') {
      title = `Перевозка грузов от 20 до 100 тонн`
    }
    const city = this.$store.state?.appState?.config?.city?.data?.prepositional;
    // const fullTitle = [title, 'в', city].filter((t) => !!t).join(" ")
    const fullTitle = title;

    return {
      title: pickSeoTitle([fullTitle], 70),
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(fullTitle, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },
  fetch: async function () {
    this.$store.commit('appState/setLoading', { category: true });
    this.$store.commit('catalog/setCategory', null);
    this.$store.commit('categoryFilters/setLoading', { key: 'get', value: true });
    this.$store.commit('categoryFilters/setFilters', []);
    await this.loadCategoryDetailed();
    await this.loadCategory(false);
    await this.getTransportList();
    this.$store.commit('appState/setLoading', { category: false });
  },

  data: function () {
    return {
      transportList: []
    }
  },

  components: {
    Breadcrumbs
  },

  mixins: [
    CategoryMixin
  ],

  computed: {
    breadcrumbs: function () {
      const categoryParent = this.category?.dynamicFields?.parent || {};

      let items = [
        { title: "Главная", path: "/" },
        { title: categoryParent?.name, path: "/gruzopodemnost" },
        { title: this.category?.name, path: this.$route.path },
      ];

      return items
    },
    afterCmsPageId: function () {
      return this.category?.dynamicFields?.after_cms_page_id || null
    },
    extensionsCategory: function () {
      return ['parent']
    },
    categoryTemplateDescription: function () {
      return this.category?.description || '';
    },
    categoryTemplateShortDescription: function () {
      return this.category?.shortDescription || '';
    },
    faqBlockValue: function () {
      return {
        categoryId: this.category?.id,

        useApi: true
      }
    },
    articlesBlockValue: function () {
      const tags = this.category?.dynamicFields?.news_tags || [];
      return {
        tags: tags,
        tagsVisibleCards: tags,
        isApi: Boolean(tags.length > 0)
      }
    },
    calculatorBlockValue: function () {
      return {
        title: this.category?.dynamicFields?.catalog_banner_title || this.category?.name,
        subtitle: [
          this.category?.dynamicFields?.catalog_banner_subtitle,
          this.category?.dynamicFields?.catalog_banner_caption_2,
          this.category?.dynamicFields?.catalog_banner_caption_3,
        ].filter((t) => !!t).join('<br/>'),
        caption: this.category?.dynamicFields?.catalog_banner_caption || "",
        image: this.category?.dynamicFields?.catalog_banner_image || this.category?.imageId,
        categoryId: this.category.id,

        subtitleFontSize: '22px', // хардкод потому что в дизайне на всех странцах разный размер!

        dark: true,
        useH1: true,
      }
    },
    typesImageFeaturesBlockValue: function () {
      const type = this.category?.dynamicFields?.category_name_genitive_case || this.category?.dynamicFields?.category_name_predlozhnom_padezhe || "";
      return {
        title: Boolean(type) && `Перевозка грузов до ${ type }`,
        products: this.products
      }
    },
    transportTypeSliderBlockValue: function () {
      let title = `Перевозка грузов до ${this.category?.name}`;
      if (this.category?.name === '20 - 100 тонн') {
        title = `Перевозка грузов от 20 до 100 тонн`
      }

      return {
        title: title,
        items: this.transportList,
        useH1: true
      }
    },
    directionsCompletedProjectsBlockValue: function () {
      const tags = this.category?.dynamicFields?.news_tags || [];
      return {
        tags: tags,
        tagsVisibleCards: tags,
        isApi: Boolean(tags.length > 0)
      }
    },

    seoTagsImageBlockValue: function () {
      const categoryName = (this.category?.name || "").toLowerCase();

      return {
        title: `Безопасно доставим ${categoryName} груз по России`,
        image: this.category?.dynamicFields?.seo_tags_image_block_image
      }
    },
    shippingCostBlockValue: function () {
      const categoryName = (this.category?.name || "");

      return {
        types: [
          {
            title: `${categoryName} груз`,
            column_one_name: "Габариты груза:",
            parameters: [
              {title: "Д × Ш × В:", params: "до 12,00 × 3,50 × 3,50 м", price: "от 150 руб./км"},
              {title: "Д × Ш × В:", params: "до 12,00 × 3,50 × 3,50 м", price: "от 200 руб./км"},
            ]
          },
          {
            title: "Тяжеловесный груз",
            column_one_name: "Масса груза:",
            parameters: [
              {title: "", params: "от 25 до 40 т", price: "от 100 руб./км"},
              {title: "", params: "от 25 до 80 т", price: "от 200 руб./км"},
            ]
          },
        ]
      }
    },
    ourFleetVehiclesTemplateBlockValue: function () {
      const categoryNameGenitiveCase = String(this.category?.dynamicFields?.category_name_predlozhnom_padezhe || this.category?.name || "").toLowerCase();

      const filters = [...this.filters].filter((t) => t.slug !== 'tip-gruza');

      return {
        category: this.category,
        products: this.products,
        pagination: {
          ...this.pagination,
          pageCount: this.pageCount
        },

        categoryTitle: `Список ${categoryNameGenitiveCase} грузов`,

        filters: filters,
        selectedFilters: this.selectedFilters,

        onChangePage: this.onChangePage.bind(this),
        onResetFilter: this.clearFilters.bind(this),
        searchProducts: this.searchProducts.bind(this),
        getUpdateFilters: this.getUpdateFilters.bind(this),
        onChangeFilterVariant: this.onChangeFilterVariant.bind(this),
      }
    },
    freightCalculatorBlockValue: function () {
      const categoryName = String(this.category?.dynamicFields?.category_name_predlozhnom_padezhe || this.category?.dynamicFields?.category_name_genitive_case || this.category?.name || "").toLowerCase().replace("<br/>", " ");

      return {
        title: `Узнать стоимость ${categoryName} перевозок`,
        cargoName: this.category?.dynamicFields?.freight_calculator_cargo_name || ""
      }
    },
    permitsTransportationOversizedCargoBlockValue: function () {
      return {
        text: `Оформление разрешения на перевозку ${String(this.categoryNameGenitiveCase || '').toLowerCase()} груза`,
        main_items: [
          {badge: "30 м", message: "по длине вместе с тягачем"},
          {badge: "5 м", message: "по ширине"},
          {badge: "5 м", message: "по высоте вместе с прицепом"},
        ]
      }
    },
    transportListTemplatesBlockValue: function () {
      const slugs = ["tip-gruza", "otrasli"];
      let filters = [];
      [...(this.filters || [])]
        .filter((t) => Boolean(slugs.includes(t.slug)))
        .map((filter) => {
          (filter?.variants || []).map((variant) => {
            filters.push(`filter[${filter.slug}][]=${variant.slug}`)
          });
        });

      if (filters.length > 0) {
        [
          this.category?.dynamicFields?.suitable_transport_1,
          this.category?.dynamicFields?.suitable_transport_2,
          this.category?.dynamicFields?.suitable_transport_3,
        ].filter((t) => !!t).map((item) => {
          filters.push(`filter[transport][]=${item}`);
        })
      }

      return {
        title: "Подберём транспорт подходящий под параметры вашего груза",
        filter: filters.join("&"),
        category: this.category,
        versionBlock: Boolean(this.category?.dynamicFields?.transport_list_templates_version) ? 2 : 1
      }
    }
  },

  methods: {
    getTransportList: async function () {
      const requestUrl = `/categories/catalog/products?per-page=999&group=2&filter[gruzopodemnost]=${this.category?.slug}`;
      const response = await this.$api.agent.transport.get(requestUrl).then((res) => {
        return res.data
      }).catch(() => {
        return []
      });
      const products = response.map((t) => new Product(t));
      this.transportList = products;
    }
  }
}
